// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import Calendar from "@pacific/XDL/Icons/Calendar";
import { xBaseTheme } from "@pacific/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        calendarIconProps: {
            ...DatePickerPresentationPropsDefault?.calendarIconProps,
            src: Calendar,
            color: "common.ui4",
        },
        cssOverrides: {
            datePicker: css`
                .react-datetime-picker {
                    &:not(:disabled),
                    &:focus-within {
                        padding: 0;
                        .react-datetime-picker__inputGroup {
                            padding-left: 9px;
                        }
                        .react-datetime-picker__button {
                            padding-right: 9px;
                        }
                    }
                    &__button {
                        padding-right: 0;
                    }
                }
            `,
        },
    },
} as xBaseTheme["datePicker"];
